import React, { useState, useEffect } from 'react';
import { Form, Button, Radio, } from 'antd';
import { EaseModal } from '../../../libs/EaseModal';
import { printRupee, handleApiExceptions, alertify } from "../../../app_methods";
import { Text1, Text4 } from '../../../styles';
import { AccountCard } from './styles';


let AccountModal = (props) => {
    const [selectedAccount, setSelectedAccount] = useState('');
    const [virtualAccounts, setVirtualAccounts] = useState([]);

    const [isUpdating, setIsUpdating] = useState(false);

    const updateSourceAccount = async () => {
        setIsUpdating(true);
        if (selectedAccount == '' && virtualAccounts.length > 1) {
            setIsUpdating(false);
            alertify('Error', "Please select source account.", 'error');
            return;
        }
        let virtual_account_id = virtualAccounts.length == 1 ? virtualAccounts[0].id : selectedAccount
        let response
        if (props.gst) {
            response = await props.gst.updateSourceAccount({ virtual_account_id: virtual_account_id })
        }
        if (props.direct_tax) {
            response = await props.direct_tax.updateSourceAccount({ virtual_account_id: virtual_account_id })
        }
        if (!response.success) {
            setIsUpdating(false);
            props.fetchChallanList();
            handleApiExceptions(response);
            return;
        }
        props.fetchChallanList();
        alertify("Success", response.data.message, "success");
        setIsUpdating(false);
        setSelectedAccount('')
        props.toggleVirtualAccountModal()
    }

    const onCancel = () => {
        setSelectedAccount('')
        props.toggleVirtualAccountModal()
    }

    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>
                Source Account
            </Text1>
        )
    };

    const renderAccounts = () => {
        return (
            <Radio.Group className="w-100 mt-1" defaultValue={virtualAccounts.length == 1 ? virtualAccounts[0].id : null}>
                {virtualAccounts ?
                    virtualAccounts.filter(va => va.status == "active").map((account, index) =>
                        <AccountCard className={`mr-1`}>
                            <div className="d-flex align-items-start">
                                <Radio id={`sa_${index}`} value={account.id} onChange={(e) => { setSelectedAccount(e.target.value) }}></Radio>
                                <label htmlFor={`sa_${index}`} style={{ width: '-webkit-fill-available', marginRight: "20px" }}>
                                    <Text4 className="d-block" strong style={{ lineHeight: "20px", whiteSpace: "initial" }} ellipsis>{account.funding_via == 1 ? account.virtual_account_number : "Credit Card Account"}</Text4>
                                    <Text4 className="d-block" type="secondary">Balance: {printRupee(account.balance, 3)}</Text4>
                                </label>
                            </div>
                        </AccountCard>
                    ) : null
                }
            </Radio.Group>
        )
    };


    useEffect(() => {
        let vas = []
        if ((props.user || {}).key) {
            if (props.gst && props.user.agtpvcc) {
                vas = props.virtualAccounts.map((va) => { if (va.provider_code == 'ICICI') { return va } }).filter((e) => { if (typeof (e) != undefined) return e }) || []
                setVirtualAccounts(vas)
            } else if (props.direct_tax && props.user.atdpvcc) {
                vas = props.virtualAccounts.map((va) => { if (va.provider_code == 'ICICI') { return va } }).filter((e) => { if (typeof (e) != undefined) return e }) || []
                setVirtualAccounts(vas)
            } else {
                vas = props.virtualAccounts.map((va) => { if (va.provider_code == 'ICICI' && va.funding_via == 1) { return va } }).filter((e) => { if (typeof (e) != undefined) return e }) || []
                setVirtualAccounts(vas)
            }
        }
    }, []);

    return (
        <EaseModal
            width={400}
            title={false}
            visible={props.visible}
            onCancel={onCancel}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <Form >
                {renderAccounts()}
                <div className="w-100 d-flex justify-content-end mt-4">
                    {props.isUpdatingSA ?
                        <Button type="primary" htmlType="button" loading={isUpdating} onClick={updateSourceAccount}><span className='mr-2' />Submit</Button>
                        :
                        <Button type="primary" htmlType="button" loading={props.loading} onClick={() => { props.onSubmit(virtualAccounts.length > 1 ? selectedAccount : virtualAccounts[0].id) }}><span className='mr-2' />Pay</Button>
                    }
                </div>
            </Form>
        </EaseModal>
    )

};

export { AccountModal };
